import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation(); 
  
  if (
    !isAuthenticated &&
    !location.pathname.startsWith("/news") &&
    !location.pathname.startsWith("/tiolsearch/columnsearch") &&
    !location.pathname.startsWith("/home/news")
  ) {
    return <Navigate to="/sign-in" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
